import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core/'
import { Check } from '@material-ui/icons'
import useStyles from './PaymentOption.style'

const PaymentOption = (props) => {
  const { label, logoSrc, selected, onClick, logoAlt = '', disabled = false } = props
  const classes = useStyles()
  return (
    <Button
      variant='outlined'
      onClick={onClick}
      disabled={disabled}
      className={`${classes.button} ${selected ? classes.selectedContainer : ''}`}>
      <Grid container alignItems='center' justify='center' className={classes.container}>
        {logoSrc && <img className={classes.logo} src={logoSrc} alt={logoAlt} />}
        <Typography align='center' variant='body2'>
          {label}
        </Typography>
        {selected && (
          <Grid item classes={{ root: classes.checkIcon }}>
            <Check color='primary' style={{ height: '100%', width: '100%' }} />
          </Grid>
        )}
      </Grid>
    </Button>
  )
}

export default PaymentOption
